/* eslint-disable react/no-unused-prop-types */
import React, { useState } from 'react';
import { styled } from '@mui/system';
import { DayPickerSingleDateController } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import '../../css/react_dates_overrides.css';

const MyThemeComponent = styled('div')(({ theme }) => ({
  '&': {
    padding: theme.spacing(1),
    background: 'transparent',
    [`.SingleDatePickerInput,
    .SingleDatePicker_picker,
    .SingleDatePicker_picker__fullScreenPortal,
    .DayPickerNavigation_button__default, 
    .DateInput_input, 
    .DateRangePickerInput, 
    .DateRangePicker_picker, 
    .DateRangePicker_picker__fullScreenPortal`]: {
      backgroundColor: theme.palette.background.paper,
    },
    [`.DayPickerKeyboardShortcuts_panel,
    .CalendarDay__default,
    .CalendarDay__outside,
    .CalendarDay__blocked_minimum_nights,
    .CalendarDay__blocked_minimum_nights:active,
    .CalendarDay__blocked_minimum_nights:hover,
    .CalendarDay__blocked_out_of_range,
    .CalendarDay__blocked_out_of_range:active,
    .CalendarDay__blocked_out_of_range:hover,
    .CalendarMonth,
    .CalendarMonthGrid,
    .DayPickerNavigation_button__verticalDefault,
    .DayPicker,
    .DayPicker__horizontal,
    .DayPicker_weekHeader__verticalScrollable,
    .DateInput,
    .DateInput_input__focused
    `]: {
      background: theme.palette.background.paper,
    },
    '.CalendarMonth_caption': {
      paddingTop: '18px',
      color: theme.palette.text.secondary,
    },
    [`.DayPickerKeyboardShortcuts_panel,
    .CalendarDay__default,
    .CalendarDay__default:hover,
    .CalendarDay__blocked_minimum_nights,
    .CalendarDay__blocked_calendar,
    .CalendarDay__blocked_calendar:active,
    .CalendarDay__blocked_calendar:hover,
    .CalendarDay__blocked_out_of_range,
    .CalendarDay__blocked_out_of_range:active,
    .CalendarDay__blocked_out_of_range:hover,
    .DateRangePickerInput__withBorder
    `]: {
      border: `1px solid ${theme.palette.divider}`,
    },
    [`.CalendarDay__hovered_offset,
    .CalendarDay__hovered_start_first_possible_end,
    .CalendarDay__hovered_start_blocked_min_nights
    `]: {
      border: `1px double ${theme.palette.divider}`,
    },
    '.DayPicker_weekHeader': {
      color: theme.palette.text.secondary,
      fontWeight: 'bold',
    },
    '.CalendarDay__default:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '.CalendarDay__default': {
      color: theme.palette.text.secondary,
      '& p': {
        fontWeight: 400,
        fontSize: theme.typography.body2.fontSize,
      },
      // padding: '2px',
    },
    [`.CalendarDay__selected,
    .CalendarDay__selected:active,
    .CalendarDay__selected:hover 
    `]: {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? 'rgba(34, 211, 238, .35)'
          : 'rgba(34, 211, 238, .55)',
      // opacity: theme.palette.action.selectedOpacity,
      border: `1px double ${theme.palette.action.selected}`,
      '& p': {
        color: theme.palette.text.primary,
        opacity: 1,
        fontWeight: 'bold',
      },
    },
    [`.DayPickerNavigation_button__default,
    .DayPickerNavigation_button__disabled,`]: {
      border: 0,
      '& .DayPickerNavigation_svg__horizontal': {
        fill: theme.palette.text.primary,
      },
    },
    [`.DayPickerNavigation_button__default:focus,
    .DayPickerNavigation_button__default:hover,
    .DayPickerNavigation_button__disabled:focus,
    .DayPickerNavigation_button__disabled:hover`]: {
      background: theme.palette.action.hover,
      border: 0,
    },
  },
}));

const DayPickerSingleDateControllerWrapper = ({
  onChange,
  initialDate,
  showInput,
  autoFocus,
  ...props
}) => {
  const [focused, setFocused] = useState(true);

  const onDateChange = (d) => {
    onChange(d);
  };

  const onFocusChange = () => setFocused(true);

  return (
    <MyThemeComponent>
      <DayPickerSingleDateController
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        onFocusChange={onFocusChange}
        onDateChange={onDateChange}
        onPrevMonthClick={onDateChange}
        onNextMonthClick={onDateChange}
        focused={focused}
        date={initialDate}
        isOutsideRange={() => false}
        hideKeyboardShortcutsPanel
      />
    </MyThemeComponent>
  );
};

export default DayPickerSingleDateControllerWrapper;
